import { Stack } from 'expo-router';

import { useAccountTabStackOptions } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function AccountTabLayout() {
  const options = useAccountTabStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen name="addresses/index" options={options.Addresses} />
      <Stack.Screen
        name="credit-and-promo-codes/index"
        options={options.CreditAndPromoCodes}
      />
      <Stack.Screen
        name="dietary-restrictions/index"
        options={options.DietaryRestrictions}
      />
      <Stack.Screen name="favorites/index" options={options.Favorites} />
      <Stack.Screen name="gift-cards/index" options={options.GiftCards} />
      <Stack.Screen
        name="gift-cards/[giftCardId]/index"
        options={options.GiftCards}
      />
      <Stack.Screen name="info/index" options={options.Profile} />
      <Stack.Screen name="menu/index" />
      <Stack.Screen
        name="notifications/index"
        options={options.Notifications}
      />
      <Stack.Screen name="orders/index" />
      <Stack.Screen name="orders/[tabId]/index" />
      <Stack.Screen
        name="payment-and-gift-cards/index"
        options={options.PaymentAndGiftCards}
      />
    </Stack>
  );
}
